/** @jsx jsx */
import { jsx, Themed } from 'theme-ui'
import { useEntity } from './helpers/selectors'
import { cf2imgix } from './helpers/imgix-image'
import { EVEntry } from './helpers/react'
import React from 'react'
import { Button } from '../atoms'

const styles = (element) => `compounds.heroCard.variants${element ? `.${element}` : ''}`

const HeroCard = ({ title, ctaText, ctaLink, children, bgImage, links, type = 'default' }) => {
  const image = useEntity(bgImage)
  const backgroundImage = cf2imgix(image?.file?.url)
  return (
    <div
      sx={{
        display: 'flex',
        variant: styles(type === 'seasonal' ? 'seasonal' : ''),
      }}
    >
      <div sx={{ variant: styles('flexContainer') }}>
        <Themed.h1 as='h2'>{title}</Themed.h1>
        {type === 'seasonal' && (
          <div
            sx={{
              variant: styles('links.seasonal'),
            }}
          >
            {links?.map((entity: any, i: number) => {
              return <EVEntry {...entity} key={i} />
            })}
          </div>
        )}
        {ctaText && (
          <Button
            variant='primary'
            href={ctaLink}
            size={children && type === 'seasonal' ? 'fullWidth' : 'small'}
            sx={{
              variant: styles('buttonLink'),
              display: ['none', 'initial'],
            }}
          >
            {ctaText}
          </Button>
        )}
      </div>
      {type === 'default' && (
        <div
          sx={{
            variant: styles('links'),
          }}
        >
          {links?.map((entity: any, i: number) => {
            return <EVEntry {...entity} key={i} />
          })}{' '}
        </div>
      )}
      {ctaText && (
        <Button
          variant='primary'
          href={ctaLink}
          size={type === 'seasonal' ? 'fullWidth' : 'small'}
          sx={{
            variant: styles('buttonLink'),
            display: ['initial', 'none'],
          }}
        >
          {ctaText}
        </Button>
      )}
      {backgroundImage && (
        <div
          sx={{
            display: ['none', 'none', 'block'],
            background: `url(${backgroundImage}) no-repeat right center / contain`,
            width: '404px',
            height: '416px',
          }}
        />
      )}
    </div>
  )
}

export default HeroCard
